(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-description"] && !Shopify.designMode) return;
  try {
    let lastUrl = window.location.href;
  setInterval(function() {
    let currentUrl = window.location.href;
    if (currentUrl !== lastUrl) {
      lastUrl = window.location.href;
      // URL has changed, now get the new parameters
      const params = new URLSearchParams(window.location.search);
      const newParamValue = params.get('variant');

      //console.log('URL changed. New value for myParameter:', newParamValue);
      if(newParamValue){
        console.log(variants_desc.get(newParamValue));
        if(variants.get(newParamValue)){
          $('.product__description').html(variants_desc.get(newParamValue));
        }
      }
    }
  }, 500); // Check every 500 milliseconds
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    let lastUrl = window.location.href;

  setInterval(function() {
    let currentUrl = window.location.href;
    if (currentUrl != lastUrl) {
      lastUrl = window.location.href;
      // URL has changed, now get the new parameters
      const params = new URLSearchParams(window.location.search);
      const newParamValue = params.get('variant');

      //console.log('URL changed. New value for myParameter:', newParamValue);
      
      if(newParamValue){
        $('.variant-inf').hide();
        $('.var-' + newParamValue).show();
      }
    }
  }, 500); // Check every 500 milliseconds
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-title"] && !Shopify.designMode) return;
  try {
    let lastUrl = window.location.href;

  setInterval(function() {
    let currentUrl = window.location.href;
    if (currentUrl != lastUrl) {
      lastUrl = window.location.href;
      // URL has changed, now get the new parameters
      const params = new URLSearchParams(window.location.search);
      const newParamValue = params.get('variant');

      //console.log('URL changed. New value for myParameter:', newParamValue);
      console.log(variants.get(newParamValue));
      if(variants.get(newParamValue)){
        $('.title_corrected').html(variants.get(newParamValue));
      }
    }
  }, 500); // Check every 500 milliseconds
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["products-availibility-notice"] && !Shopify.designMode) return;
  try {
    let lastUrl = window.location.href;

  setInterval(function() {
    let currentUrl = window.location.href;
    if (currentUrl != lastUrl) {
      lastUrl = window.location.href;
      // URL has changed, now get the new parameters
      const params = new URLSearchParams(window.location.search);
      const newParamValue = params.get('variant');

      //console.log('URL changed. New value for myParameter:', newParamValue);
      
      if(newParamValue){
        $('.variant-mess').hide();
        $('.var-' + newParamValue).show();
      }
    }
  }, 500); // Check every 500 milliseconds
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["products-metadata"] && !Shopify.designMode) return;
  try {
    let lastUrl = window.location.href;

  setInterval(function() {
    let currentUrl = window.location.href;
    if (currentUrl != lastUrl) {
      lastUrl = window.location.href;
      // URL has changed, now get the new parameters
      const params = new URLSearchParams(window.location.search);
      const newParamValue = params.get('variant');

      //console.log('URL changed. New value for myParameter:', newParamValue);
      
      if(newParamValue){
        $('.variant-meta').hide();
        $('.var-' + newParamValue).show();
      }
    }
  }, 500); // Check every 500 milliseconds
  } catch(e) { console.error(e); }
})();

})();
